import React from 'react';
import { createRoot } from 'react-dom/client';
import { init } from '@sentry/react';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import relativeTime from 'dayjs/plugin/relativeTime';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import weekday from 'dayjs/plugin/weekday';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';
import localeData from 'dayjs/plugin/localeData';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { initAuth } from '@auth';
import { env } from '@utils/env';
import { initMatomo } from '@utils/matomo';

import App from './App';

import 'antd/dist/reset.css';

dayjs.extend(utc);
dayjs.extend(relativeTime);
dayjs.extend(quarterOfYear);
dayjs.extend(weekday);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
dayjs.extend(localeData);
dayjs.extend(customParseFormat);

if (import.meta.env.MODE !== 'development') {
  init({
    dsn: env.VITE_SENTRY_DSN,
    maxBreadcrumbs: 50,
    environment: import.meta.env.MODE,
  });
}

// Load analytics in production only. Fully guarded: a missing container URL or
// an unreachable analytics host never breaks the app (see @utils/matomo).
if (import.meta.env.MODE === 'production') {
  initMatomo();
}

// Nothing auth-dependent renders and no request is sent until OIDC init has settled, so the router
// never sees a "still deciding" state. initAuth resolves either way; it does not reject.
initAuth().finally(() => {
  createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
